module.exports = __webpack_public_path__ + "static/media/oekotex.bf803c99.png";